module.exports = {
      id: "lifestyle-usage",
      viewBox: "0 0 24.217 32.155",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#lifestyle",
      toString: function () {
        return this.url;
      }
    }